import React from 'react';
import './InfoPage.css';

function Terms() {
  return (
    <div className="info-page">
      <div className="info-container">
        <h1>Termos de Serviço</h1>

        <div className="effective-date">
          Data de Vigência: 1 de novembro de 2024
        </div>

        <section className="legal-section">
          <h2>Bem-vindo à Nukki</h2>
          <p>Estes Termos de Serviço ("Termos") regem seu acesso e uso da plataforma, site e serviços da Nukki. Por favor, leia-os com atenção.</p>
          <p>Ao acessar ou usar a Nukki, você concorda em estar vinculado a estes Termos e à nossa Política de Privacidade. Se você não concordar, não poderá usar nossos serviços.</p>
        </section>

        <section className="legal-section">
          <h3>1. Definições</h3>
          <ul>
            <li><strong>"Nukki," "nós," "nos,"</strong> refere-se à Nukki, Inc.</li>
            <li><strong>"Plataforma"</strong> significa o site, aplicativos móveis e serviços da Nukki</li>
            <li><strong>"Anfitrião"</strong> significa um usuário que lista acomodações ou experiências</li>
            <li><strong>"Hóspede"</strong> significa um usuário que reserva acomodações ou experiências</li>
            <li><strong>"Anúncio"</strong> significa uma acomodação ou experiência postada por um Anfitrião</li>
            <li><strong>"Reserva"</strong> significa uma reserva confirmada feita através da Plataforma</li>
          </ul>
        </section>

        <section className="legal-section">
          <h3>2. Elegibilidade</h3>
          <p>Para usar a Nukki, você deve:</p>
          <ul>
            <li>Ter pelo menos 18 anos de idade</li>
            <li>Ter capacidade legal para celebrar um contrato vinculativo</li>
            <li>Não estar proibido de usar o serviço sob a lei aplicável</li>
            <li>Cumprir todas as leis e regulamentos aplicáveis</li>
            <li>Não ter sido banido anteriormente da Plataforma</li>
          </ul>
        </section>

        <section className="legal-section">
          <h3>3. Registro de Conta</h3>

          <h4>3.1 Criação de Conta</h4>
          <p>Você deve criar uma conta para usar a maioria dos recursos da Plataforma. Você concorda em:</p>
          <ul>
            <li>Fornecer informações precisas, atuais e completas</li>
            <li>Manter e atualizar suas informações</li>
            <li>Manter sua senha segura e confidencial</li>
            <li>Não compartilhar sua conta com outras pessoas</li>
            <li>Notificar-nos imediatamente sobre acesso não autorizado</li>
          </ul>

          <h4>3.2 Verificação de Conta</h4>
          <p>Podemos exigir verificação de identidade antes que você possa reservar ou listar propriedades. Você nos autoriza a:</p>
          <ul>
            <li>Solicitar informações ou documentação adicionais</li>
            <li>Usar serviços de verificação de terceiros</li>
            <li>Realizar verificações de antecedentes quando permitido por lei</li>
          </ul>

          <h4>3.3 Responsabilidades da Conta</h4>
          <p>Você é responsável por todas as atividades que ocorrem em sua conta. Não somos responsáveis por perdas causadas pelo uso não autorizado de sua conta.</p>
        </section>

        <section className="legal-section">
          <h3>4. Usando a Plataforma</h3>

          <h4>4.1 Licença</h4>
          <p>Sujeito a estes Termos, concedemos a você uma licença limitada, não exclusiva e intransferível para acessar e usar a Plataforma para fins pessoais e não comerciais.</p>

          <h4>4.2 Atividades Proibidas</h4>
          <p>Você não pode:</p>
          <ul>
            <li>Violar quaisquer leis ou regulamentos</li>
            <li>Infringir direitos de propriedade intelectual</li>
            <li>Publicar conteúdo falso, enganoso ou fraudulento</li>
            <li>Assediar, abusar ou prejudicar outras pessoas</li>
            <li>Discriminar com base em características protegidas</li>
            <li>Raspar, rastrear ou coletar dados da Plataforma</li>
            <li>Fazer engenharia reversa ou tentar acessar o código-fonte</li>
            <li>Introduzir vírus, malware ou código prejudicial</li>
            <li>Contornar recursos de segurança ou limitações técnicas</li>
            <li>Criar múltiplas contas para evitar restrições</li>
            <li>Participar de atividades comerciais fora da Plataforma</li>
          </ul>
        </section>

        <section className="legal-section">
          <h3>5. Hospedagem na Nukki</h3>

          <h4>5.1 Listagem de Acomodações</h4>
          <p>Como Anfitrião, você é responsável por:</p>
          <ul>
            <li>Precisão das informações do anúncio, fotos e descrições</li>
            <li>Definir seus próprios preços e disponibilidade</li>
            <li>Conformidade com leis e regulamentos aplicáveis</li>
            <li>Obter licenças, autorizações e seguros necessários</li>
            <li>Pagamento de impostos aplicáveis</li>
            <li>Manter sua propriedade em condições seguras e habitáveis</li>
          </ul>

          <h4>5.2 Padrões de Anfitriões</h4>
          <p>Os Anfitriões devem:</p>
          <ul>
            <li>Honrar as reservas confirmadas, a menos que circunstâncias excepcionais se apliquem</li>
            <li>Responder às consultas prontamente</li>
            <li>Manter calendários precisos</li>
            <li>Fornecer anúncios conforme descritos</li>
            <li>Tratar os hóspedes com respeito e sem discriminação</li>
            <li>Cumprir nossa Política de Conteúdo e Padrões da Comunidade</li>
          </ul>

          <h4>5.3 Cancelamentos de Anfitriões</h4>
          <p>Os cancelamentos de anfitriões prejudicam nossa comunidade. Cancelar reservas confirmadas pode resultar em:</p>
          <ul>
            <li>Taxas de cancelamento</li>
            <li>Classificação de pesquisa reduzida</li>
            <li>Perda do status de Superanfitrião</li>
            <li>Suspensão ou remoção da conta</li>
          </ul>
        </section>

        <section className="legal-section">
          <h3>6. Reservas na Nukki</h3>

          <h4>6.1 Fazendo Reservas</h4>
          <p>Como Hóspede, você concorda em:</p>
          <ul>
            <li>Ler as descrições dos anúncios e regras da casa com atenção</li>
            <li>Pagar todos os valores devidos de acordo com o cronograma de pagamento</li>
            <li>Deixar a propriedade em boas condições</li>
            <li>Seguir as regras da casa e leis locais</li>
            <li>Respeitar a propriedade e os vizinhos</li>
            <li>Representar com precisão o número de hóspedes</li>
          </ul>

          <h4>6.2 Cancelamentos e Reembolsos</h4>
          <p>Os termos de cancelamento são definidos pelos Anfitriões e exibidos antes da reserva. Os reembolsos são fornecidos de acordo com a política de cancelamento aplicável.</p>

          <h4>6.3 Responsabilidades do Hóspede</h4>
          <p>Os Hóspedes são responsáveis por:</p>
          <ul>
            <li>Danos à propriedade além do desgaste normal</li>
            <li>Itens perdidos ou danificados</li>
            <li>Limpeza adicional necessária</li>
            <li>Violações das regras da casa ou leis locais</li>
          </ul>
        </section>

        <section className="legal-section">
          <h3>7. Pagamentos e Taxas</h3>

          <h4>7.1 Taxas de Serviço</h4>
          <p>A Nukki cobra taxas de serviço de Hóspedes e Anfitriões pelo uso da Plataforma. As taxas são divulgadas antes da reserva e não são reembolsáveis, exceto conforme exigido por lei.</p>

          <h4>7.2 Processamento de Pagamento</h4>
          <p>Todos os pagamentos são processados através de nossos parceiros de pagamento. Você nos autoriza a cobrar seu método de pagamento por todas as taxas e encargos.</p>

          <h4>7.3 Pagamentos aos Anfitriões</h4>
          <p>Os Anfitriões são pagos aproximadamente 24 horas após o check-in do hóspede, sujeito às nossas políticas de pagamento e quaisquer retenções por possíveis problemas.</p>

          <h4>7.4 Impostos</h4>
          <p>Você é responsável por determinar e pagar os impostos aplicáveis. Em algumas jurisdições, podemos coletar e remeter impostos em seu nome.</p>
        </section>

        <section className="legal-section">
          <h3>8. Avaliações e Classificações</h3>
          <p>As avaliações devem ser:</p>
          <ul>
            <li>Baseadas em experiências reais</li>
            <li>Verdadeiras e precisas</li>
            <li>Respeitosas e apropriadas</li>
            <li>Livres de conflitos de interesse</li>
            <li>Não usadas para extorsão ou ameaças</li>
          </ul>
          <p>Podemos remover avaliações que violem nossa Política de Conteúdo.</p>
        </section>

        <section className="legal-section">
          <h3>9. Conteúdo</h3>

          <h4>9.1 Seu Conteúdo</h4>
          <p>Você mantém a propriedade do conteúdo que publica. Ao publicar conteúdo, você nos concede uma licença mundial, não exclusiva e livre de royalties para usar, exibir e distribuir seu conteúdo em conexão com a Plataforma.</p>

          <h4>9.2 Padrões de Conteúdo</h4>
          <p>Todo o conteúdo deve estar em conformidade com nossa Política de Conteúdo e não deve:</p>
          <ul>
            <li>Ser ilegal, prejudicial ou ofensivo</li>
            <li>Infringir direitos de propriedade intelectual</li>
            <li>Conter informações pessoais de outras pessoas sem permissão</li>
            <li>Ser falso ou enganoso</li>
          </ul>

          <h4>9.3 Remoção de Conteúdo</h4>
          <p>Reservamo-nos o direito de remover conteúdo que viole estes Termos ou nossas políticas.</p>
        </section>

        <section className="legal-section">
          <h3>10. Propriedade Intelectual</h3>
          <p>A Plataforma e seu conteúdo (excluindo conteúdo do usuário) são de propriedade da Nukki e protegidos por direitos autorais, marcas registradas e outras leis. Você não pode usar nossa propriedade intelectual sem permissão.</p>
        </section>

        <section className="legal-section">
          <h3>11. Disputas Entre Usuários</h3>
          <p>Você é responsável pelas interações com outros usuários. Embora possamos ajudar a facilitar resoluções, não somos responsáveis por disputas entre usuários. Você isenta a Nukki de reivindicações e danos decorrentes de disputas com outros usuários.</p>
        </section>

        <section className="legal-section">
          <h3>12. Limitação de Responsabilidade</h3>
          <p>NA MÁXIMA EXTENSÃO PERMITIDA POR LEI:</p>
          <ul>
            <li>A NUKKI NÃO É RESPONSÁVEL POR DANOS INDIRETOS, INCIDENTAIS, ESPECIAIS OU CONSEQUENCIAIS</li>
            <li>NOSSA RESPONSABILIDADE TOTAL NÃO EXCEDERÁ OS VALORES PAGOS A NÓS NOS 12 MESES ANTERIORES AO EVENTO</li>
            <li>NÃO SOMOS RESPONSÁVEIS PELA CONDUTA DOS USUÁRIOS OU PELA CONDIÇÃO DOS ANÚNCIOS</li>
          </ul>
        </section>

        <section className="legal-section">
          <h3>13. Isenções de Responsabilidade</h3>
          <p>A PLATAFORMA É FORNECIDA "COMO ESTÁ" SEM GARANTIAS DE QUALQUER TIPO. ISENTAMOS TODAS AS GARANTIAS, EXPRESSAS OU IMPLÍCITAS, INCLUINDO COMERCIALIZAÇÃO, ADEQUAÇÃO A UM PROPÓSITO ESPECÍFICO E NÃO VIOLAÇÃO.</p>
        </section>

        <section className="legal-section">
          <h3>14. Indenização</h3>
          <p>Você concorda em indenizar e isentar a Nukki de reivindicações, danos e despesas (incluindo honorários legais) decorrentes do seu uso da Plataforma, violação destes Termos ou violação dos direitos de terceiros.</p>
        </section>

        <section className="legal-section">
          <h3>15. Rescisão</h3>
          <p>Podemos suspender ou encerrar sua conta a qualquer momento por:</p>
          <ul>
            <li>Violação destes Termos</li>
            <li>Atividade fraudulenta ou ilegal</li>
            <li>Risco à segurança ou proteção</li>
            <li>A nosso exclusivo critério</li>
          </ul>
          <p>Você pode fechar sua conta a qualquer momento através das configurações da conta.</p>
        </section>

        <section className="legal-section">
          <h3>16. Resolução de Disputas</h3>

          <h4>16.1 Lei Aplicável</h4>
          <p>Estes Termos são regidos pelas leis do Estado da Califórnia, sem considerar os princípios de conflito de leis.</p>

          <h4>16.2 Arbitragem</h4>
          <p>Quaisquer disputas decorrentes destes Termos ou do seu uso da Plataforma serão resolvidas através de arbitragem vinculativa, exceto quando proibido por lei.</p>

          <h4>16.3 Renúncia de Ação Coletiva</h4>
          <p>Você concorda em apresentar reivindicações apenas em sua capacidade individual e não como parte de qualquer ação coletiva ou representativa.</p>
        </section>

        <section className="legal-section">
          <h3>17. Disposições Gerais</h3>

          <h4>17.1 Alterações aos Termos</h4>
          <p>Podemos modificar estes Termos a qualquer momento. Alterações materiais serão notificadas por e-mail ou através da Plataforma. O uso continuado após as alterações constitui aceitação.</p>

          <h4>17.2 Divisibilidade</h4>
          <p>Se qualquer disposição for considerada inexequível, as disposições restantes continuam em vigor.</p>

          <h4>17.3 Não Renúncia</h4>
          <p>Nossa falha em fazer cumprir qualquer direito ou disposição não constitui uma renúncia.</p>

          <h4>17.4 Acordo Integral</h4>
          <p>Estes Termos constituem o acordo integral entre você e a Nukki.</p>
        </section>

        <section className="legal-section">
          <h3>18. Informações de Contato</h3>
          <div className="feature-box">
            <p><strong>E-mail:</strong> legal@nukki.com</p>
            <p><strong>Endereço:</strong> Departamento Jurídico da Nukki<br/>
            123 Market Street<br/>
            San Francisco, CA 94103</p>
          </div>
        </section>

        <section className="legal-section">
          <p><em>Última atualização: 1 de novembro de 2024</em></p>
        </section>
      </div>
    </div>
  );
}

export default Terms;
